/**
 * Created by shiyonggao on 2019/2/25.
 */

const handle = {
    getSelectedServerData(serverList, act_server_id) {
        let data = null;
        for (let key in serverList) {
            if (parseInt(serverList[key]['server_sid']) === parseInt(act_server_id)) {
                data = serverList[key];
                break;
            }
        }
        return data;
    }
};

const state = {
    serverList: [],  //服务器列表
    selectedServerId: 0,  //被选择的服务器ID
    selectedServerData: [] //被选择的服务器相关属性
};

const actions = {

    /**
     * 获取服务器列表
     * @param sid
     * @constructor
     */
    GET_SERVER_LIST({state, commit, rootState}){
        const versionInfo = rootState.$appConfig.getVersionInfo();
        let url = versionInfo.api.app_base_url + versionInfo.api.app_get_server;
        let params = {
            merchant_shop_code: rootState.$appConfig.PARAMS.merchant_shop_code,
            user_id: rootState.$appConfig.PARAMS.user_id
        };

        rootState.$common.ajax({
            url: url,
            data: params,
            success(res) {
                if (res.code === 200) {
                    console.log('AJAX_GET_SERVER_LIST', res);
                    commit('SET_SERVER_LIST', res);

                    //设置默认选择服务器
                    if (!rootState.$appConfig.PARAMS.server_id || !handle.getSelectedServerData(res.result, rootState.$appConfig.PARAMS.server_id)) {
                        state.selectedServerId = res.result[0]['server_sid'];
                        rootState.$appConfig.PARAMS.server_id = state.selectedServerId;
                        console.log('USE_SERVER_LIST_FRIST_LOG=>', res.result[0]);
                    } else {
                        state.selectedServerId = rootState.$appConfig.PARAMS.server_id;
                    }

                    console.log('GET_SERVER_LIST_STATE=>',state);
                    commit('SET_SELECTED_SERVER_DATA_M', state.selectedServerId);
                    commit('SET_AJAX_STATUS', ['serverList', true], {root: true});
                }
            },
            error(res) {
                console.log('AJAX_SERVER_LIST_FAIL=>', res);
            }
        });

    },
    /**
     * 用户切换游戏服务器事件
     * @param state
     * @param commit
     * @param rootState
     * @param sid
     * @constructor
     */
    CLICK_SELECTED_SERVER_DATA({state, commit, rootState}, sid) {
        commit('SET_SELECTED_SERVER_DATA_M', sid);
    },


};

const getters = {};

const mutations = {
    /**
     * 设置serverList数据
     * @param state
     * @param res
     * @constructor
     */
    SET_SERVER_LIST(state, res) {
        state.serverList = res.result;
    },

    /**
     * 用户切换游戏服务器事件
     * @param state
     * @param sid
     * @constructor
     */
    SET_SELECTED_SERVER_DATA_M(state, sid) {
        state.selectedServerData = handle.getSelectedServerData(state.serverList, sid);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./website/store/modules/get_server_info.js